// src/utils/validation.js

export function validatePhoneNumber(phone) {
  // Simple regex for 10-digit phone number (adjust as needed)
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
}

export function validatePassword(password) {
  /*
    Password Rules:
    - Minimum 8 characters
    - At least 1 uppercase letter
    - At least 1 lowercase letter
    - At least 1 number
    - At least 1 special character
  */

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]{8,}$/;

  return passwordRegex.test(password);
}
export function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};